export const contactLinks = [
  {
    id: 'line',
    label: 'LINE',
    href: 'https://lin.ee/XpHRuZa',
    display: 'Wedding Tech',
    description: 'Reach us on LINE for real-time planning support and fast updates.',
    iconClass: 'fab fa-line',
    featured: true,
    cta: 'Chat on LINE',
    external: true,
  },
  {
    id: 'instagram',
    label: 'Instagram',
    href: 'https://www.instagram.com/wedding.tech.official',
    display: '@wedding.tech.official',
    description: 'Browse inspiration, latest launches, and behind-the-scenes stories.',
    iconClass: 'fab fa-instagram',
    featured: true,
    cta: 'View Instagram',
    external: true,
  },
  {
    id: 'facebook',
    label: 'Facebook',
    href: 'https://www.facebook.com/profile.php?id=61582763717782',
    display: 'Wedding Tech',
    description: 'Join our community for tips, announcements, and live event coverage.',
    iconClass: 'fab fa-facebook-f',
    featured: true,
    cta: 'Visit Facebook',
    external: true,
  },
  {
    id: 'email',
    label: 'Email',
    href: 'mailto:wedding.tech.contact@gmail.com',
    display: 'wedding.tech.contact@gmail.com',
    description: 'Prefer email? Send us the details and we’ll craft a custom proposal.',
    iconClass: 'fas fa-envelope',
    featured: false,
    cta: 'Send an Email',
    external: false,
  },
];
